import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import LoadingOverlay from '../common/LoadingOverlay';

const ProtectedRoute = ({ children }) => {
  const { user, isLoading, error } = useAuth();

  if (isLoading) {
    return <LoadingOverlay message="Chargement..." />;
  }

  if (!user || error) {
    // If there's a whitelist error, redirect with error parameter
    if (error === 'whitelist') {
      return <Navigate to="/login?error=not_whitelisted" replace />;
    }
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
